import { Box, Card, CardContent, Typography } from '@mui/material'

export default function PaymentProofsPage() {
    return (
        <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Payment Proofs</Typography>
            <Card>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body1" sx={{ color: 'grey.500' }}>
                        Payment proof verification will be shown here. Upload screenshots will be verified and orders will be confirmed.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}
